import { Box, Heading, Stack, Image, Text } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper";

export default function BuyerStories() {
    return (
        <Stack alignItems="center" my={8}>
            <Heading fontSize={{base:"24px",md:"31px"}} py={{base:8,md:10}} fontWeight={"semibold"}>
                Buyer Stories
            </Heading>
            <Box width="100%" py={{base:8,md:10}}>
                <Swiper
                    slidesPerView={"4"}
                    spaceBetween={30}
                    pagination={{
                        clickable: true,
                    }}
                    loop={true}
                    navigation={true}
                    breakpoints={{
                        "0": {
                          slidesPerView: 1,
                          spaceBetween: 30,
                        },
                        "580": {
                          slidesPerView: 2,
                          spaceBetween: 30,
                        },
                        "1000": {
                          slidesPerView: 3,
                          spaceBetween: 40,
                        },
                        "1350": {
                          slidesPerView: 4,
                          spaceBetween: 50,
                        },
                      }}
                    className="mySwiper marketplace-slider"
                    modules={[Navigation]}
                >
                    {data.map((item,index) => {

                        return (
                            <SwiperSlide key={index}>
                                <Box  >
                                    <Image width="100%" src={item.imageUrl} />
                                    <Stack alignItems="center" py={5} bg="#F7F7F7" px={2}>
                                        <Text color="#888888" maxWidth={{md:"250px"}} align="center" fontWeight={"medium"}  fontSize={{base:"18px",md:"12px"}}>
                                            {item.description}
                                        </Text>
                                        <Text width="170px" fontSize="20px" fontWeight={"semibold"} py={2} color={{md:"gray.500"}} align="center">
                                            {item.title}
                                        </Text>
                                    </Stack>
                                </Box>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Box>

        </Stack>
    )
};

const data = [
    {
        title: "Suzan-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/suzan.png"
    },
    {
        title: "Chris-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/chris.png"
    },
    {
        title: "Suzan-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/suzan.png"
    },
    {
        title: "Chris-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/chris.png"
    },
    {
        title: "Suzan-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/suzan.png"
    },
    {
        title: "Chris-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/chris.png"
    },
    {
        title: "Suzan-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/suzan.png"
    },
    {
        title: "Chris-CEO",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis quis massa semper",
        imageUrl: "/images/become-a-seller/chris.png"
    },
]